import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-bulk-mails',
  templateUrl: './bulk-mails.component.html',
  styleUrls: ['./bulk-mails.component.css']
})
export class BulkMailsComponent implements OnInit {
    public grid?: GridOptions;

    constructor(private stateService: StateService) {

    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_bulkmails_grid')
                .setLoadDataFunction({
                    method: 3102,
                    parameters: {}
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true })
                .setCustomToolbarButtons([{
                    name: 'bulkmails_new',
                    text: 'bulkmails_new',
                    tooltip: 'bulkmails_new',
                    translateTooltip: true,
                    func: () => this.stateService?.go('bulkmail', { bulkmail_keyno: '0' }),
                    icon: 'fas fa-plus',
                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                    translate: true
                }]);
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}
